import { render, staticRenderFns } from "./GlobalDictionariesSection.vue?vue&type=template&id=00f9b729"
import script from "./GlobalDictionariesSection.vue?vue&type=script&lang=js"
export * from "./GlobalDictionariesSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.33_babel-core@7.0.0-bridge.0_@babel+core@7.29.0__cac_3x63j6yfs4ywkbohjqsijm4vsu/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports